"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _react = _interopRequireWildcard(require("react"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

require("./_mention-tag.scss");

function MentionTag(_ref) {
  var offsetkey = _ref.offsetkey,
      children = _ref.children;
  return _react["default"].createElement("span", {
    "data-offset-key": offsetkey,
    className: "mention-tag"
  }, children);
}

var _default = (0, _react.memo)(MentionTag);

exports["default"] = _default;